// Page changes should feel instant (owner 26 ก.ย. 69: "กดแล้วต้องรอประมาณ 500ms ถึงจะเปลี่ยนหน้ารู้สึกไม่ลื่นเลย").
// Each page (dashboard, settings, knowledge…) is its own file, fetched on the first click — 2–3 files in a row over
// the network while the old page just sits there. After sign-in, when the browser is idle, fetch every page ahead of
// time; and if a click still has to wait, show the thin top bar right away.
import type { Router } from 'vue-router'
import { ref } from 'vue'

export const navigating = ref(false)

let prefetched = false

type Loader = () => Promise<unknown>

function loaders(router: Router): Loader[] {
  const out: Loader[] = []
  for (const r of router.getRoutes()) {
    const c = r.components?.default
    if (typeof c === 'function') out.push(c as Loader)
  }
  return out
}

/** Once per page load, when idle: every lazy page + the settings sections (defineAsyncComponent). */
export function prefetchPages(router: Router): void {
  if (prefetched) return
  prefetched = true
  const run = (): void => {
    for (const load of loaders(router)) void load().catch(() => undefined)
    void import('../components/config/sections')
      .then((m) => {
        for (const s of m.CONFIG_SECTIONS) {
          const loader = (s.component as { __asyncLoader?: Loader }).__asyncLoader
          if (loader) void loader().catch(() => undefined)
        }
      })
      .catch(() => undefined)
  }
  const w = window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number }
  if (w.requestIdleCallback) w.requestIdleCallback(run, { timeout: 3000 })
  else window.setTimeout(run, 1500)
}

/** Thin top bar while a page change waits (only if it takes longer than a blink). */
export function installNavProgress(router: Router): void {
  let timer: number | undefined
  const stop = (): void => {
    window.clearTimeout(timer)
    navigating.value = false
  }
  router.beforeEach((to, from) => {
    if (to.name !== from.name) {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => (navigating.value = true), 80)
    }
    return true
  })
  router.afterEach(stop)
  router.onError(stop)
}
